//import Vue from 'vue';
import BzbsApi from '@/service/BzbsApi.js';

/**
 * @method apiGetShoppingCartItem
 */
export default {
    /**
     * Get cart's item amount.
     * @param {String} token
     */
    apiGetCartCount: function(strBzbsToken,apiShoppingCartUrl) {
        var url = `${apiShoppingCartUrl}/cart/count`;
        var params = {};
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsGet(url, strBzbsToken, params)
                .then((response) => {

                    resolve(response);
                }).catch((error) => {
                    reject(error);
                });

        });
    },
    /**
     * Get total item's quantity in cart.
     * @param {String} token
     */
    apiGetCartQuantityCount: function(token,apiShoppingCartUrl) {
        return this.apiGetCartList(token,apiShoppingCartUrl).then((data) => {
            var total = 0;
            var list = data.data.list;
            if (list) {
                for (var items of list) {
                    for (var item of items.items) {
                        total += item.Quantity;
                    }
                }
            }
            return total;
        }).catch(() => {
            return 0;
        });
    },

    /**
     * Get cart's list.
     * @param {String} token
     */
    apiGetCartList: function(strBzbsToken,apiShoppingCartUrl) {
        var url = `${apiShoppingCartUrl}/cart/list_summary`;

        var params = {};
        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsGet(url, strBzbsToken, params)
                .then((response) => {

                    resolve(response);
                }).catch((error) => {
                    reject(error);
                });

        });
    },

    /**
     * Add item(s) to cart.
     * @param {string} strBzbsToken
     * @param {Object} cartParams /core/ShoppingCart/model/AddCartModel.js
     */
    apiAddToCart: (strBzbsToken, cartParams, apiShoppingCartUrl) => {
        var url = `${apiShoppingCartUrl}/cart/adds`;

        return new Promise((resolve, reject) => {
            BzbsApi.connectBzbsPost(url, strBzbsToken, cartParams)
                .then((response) => {

                    resolve(response);
                }).catch((error) => {
                    reject(error);
                });

        });
    },
}
